<template>
  <section class="hero">
    <div class="hero-grid"></div>
    <div class="hero-content">
      <div class="hero-text">
        <div class="hero-badge">
          <span class="badge-dot"></span>
          Solutions financières inclusives
        </div>
        <h1>
          La <span class="highlight">microfinance</span><br>
          simple, pour tous
        </h1>
        <p>
          OASIS FINANCE, votre partenaire de confiance pour l'épargne et le crédit. 
          Des solutions adaptées à vos besoins, sans frais cachés, avec un accompagnement personnalisé.
        </p>
        <div class="hero-buttons">
          <a href="#services" class="btn btn-gold" @click.prevent="scrollTo('services')">
            Découvrir nos services
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </a>
          <a href="#contact" class="btn btn-ghost" @click.prevent="scrollTo('contact')">
            Demander un rendez-vous
          </a>
        </div>
      </div>

      <div class="hero-visual">
        <div class="hero-image-wrapper">
          <img src="/accueil3.jpg" alt="Agence Oasis Finance">
        </div>
        <div class="floating-stat stat-1">
          <div class="number">15K+</div>
          <div class="label">Clients satisfaits</div>
        </div>
        <div class="floating-stat stat-2">
          <div class="number">24h</div>
          <div class="label">Délai de réponse</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  methods: {
    scrollTo(id) {
      const element = document.getElementById(id)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }
  }
}
</script>

<style scoped>
.hero {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  overflow: hidden;
  background: linear-gradient(135deg, var(--primary-blue) 0%, #0d3a7a 50%, #1e5bb5 100%);
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('../assets/image/accueil3.jpg') center/cover no-repeat;
  opacity: 0.1;
}

.hero::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 80%, rgba(37, 99, 235, 0.3) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(245, 158, 11, 0.2) 0%, transparent 50%);
}

.hero-grid {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px);
  background-size: 60px 60px;
  animation: gridMove 20s linear infinite;
}

@keyframes gridMove {
  0% { transform: translate(0, 0); }
  100% { transform: translate(60px, 60px); }
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 1400px;
  margin: 0 auto;
  padding: 8rem 2rem 4rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
}

.hero-text {
  color: var(--white);
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50px;
  font-size: 0.85rem;
  font-weight: 500;
  margin-bottom: 1.5rem;
  backdrop-filter: blur(10px);
  animation: fadeInUp 0.8s ease forwards;
}

.badge-dot {
  width: 8px;
  height: 8px;
  background: var(--accent-green);
  border-radius: 50%;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.5; transform: scale(1.2); }
}

.hero h1 {
  font-family: var(--font-display);
  font-size: clamp(2.5rem, 5vw, 4rem);
  font-weight: 700;
  line-height: 1.1;
  margin-bottom: 1.5rem;
  animation: fadeInUp 0.8s ease 0.1s forwards;
  opacity: 0;
}

.hero h1 .highlight {
  background: linear-gradient(135deg, var(--accent-gold), #FCD34D);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero p {
  font-size: 1.15rem;
  line-height: 1.8;
  opacity: 0.9;
  max-width: 520px;
  margin-bottom: 2rem;
  animation: fadeInUp 0.8s ease 0.2s forwards;
  opacity: 0;
}

.hero-buttons {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  animation: fadeInUp 0.8s ease 0.3s forwards;
  opacity: 0;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 2rem;
  font-family: var(--font-body);
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  transition: var(--transition-base);
}

.btn-gold {
  background: linear-gradient(135deg, var(--accent-gold), #D97706);
  color: var(--white);
}

.btn-gold:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(245, 158, 11, 0.4);
}

.btn-ghost {
  background: rgba(255, 255, 255, 0.1);
  color: var(--white);
  border: 2px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
}

.btn-ghost:hover {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.5);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.hero-visual {
  position: relative;
  animation: fadeInUp 1s ease 0.4s forwards;
  opacity: 0;
}

.hero-image-wrapper {
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: var(--shadow-2xl);
}

.hero-image-wrapper::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 24px;
  padding: 2px;
  background: linear-gradient(135deg, rgba(255,255,255,0.3), transparent);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  pointer-events: none;
}

.hero-image-wrapper img {
  width: 100%;
  height: auto;
  display: block;
}

.floating-stat {
  position: absolute;
  background: var(--white);
  padding: 1rem 1.5rem;
  border-radius: 16px;
  box-shadow: var(--shadow-xl);
  animation: float 4s ease-in-out infinite;
}

.floating-stat.stat-1 {
  top: 10%;
  right: -10%;
  animation-delay: 0s;
}

.floating-stat.stat-2 {
  bottom: 20%;
  left: -10%;
  animation-delay: 1s;
}

.floating-stat .number {
  font-family: var(--font-display);
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--primary-blue);
}

.floating-stat .label {
  font-size: 0.8rem;
  color: var(--gray-600);
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-15px); }
}

@media (max-width: 1024px) {
  .hero-content {
    grid-template-columns: 1fr;
    text-align: center;
    padding-top: 7rem;
  }

  .hero-text {
    order: 1;
  }

  .hero p {
    margin-left: auto;
    margin-right: auto;
  }

  .hero-buttons {
    justify-content: center;
  }

  .hero-visual {
    order: 2;
    max-width: 500px;
    margin: 0 auto;
  }

  .floating-stat {
    display: none;
  }
}

@media (max-width: 768px) {
  .hero-buttons {
    flex-direction: column;
    align-items: center;
  }

  .btn {
    width: 100%;
    max-width: 300px;
    justify-content: center;
  }
}
</style>
